import validator from 'validator';

export default class AccessToken {
  readonly value: any;

  constructor(value: any) {
    if (validator.isEmpty(value)) {
      throw Error(
        'The given value for constructing the `AccessToken` object is invalid.',
      );
    }

    this.value = value;
  }

  equals(other: AccessToken): boolean {
    return this.value === other.value;
  }
}
